module.exports = __webpack_public_path__ + "img/MG-LIVEPEN-07.ef61a136.png";